import {
  Box,
  Container,
  Grid,
  Typography,
  Button,
  useTheme,
} from "@mui/material";
import { motion } from "framer-motion";
import { blogPosts } from "../data/blog";
import { BlogCard } from "./BlogCard";
import { useNavigate } from "react-router-dom";
import AutoStoriesIcon from "@mui/icons-material/AutoStories";

export const BlogSection = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const latestPosts = [...blogPosts]
    .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
    .slice(0, 3);

  const onHoverStyle = {
    "&:hover": {
      "& svg": {
        color: "secondary.main",
      },
    },
  };

  return (
    <Box sx={{ py: 8 }}>
      <Container>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 20 }}
          transition={{ duration: 0.5 }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: { xs: "center", sm: "space-between" },
              alignItems: "center",
              mb: 6,
            }}
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { xs: "2rem", md: "2.5rem" },
                fontWeight: 600,
                textAlign: { xs: "center", sm: "left" },
              }}
            >
              Latest Blog Posts
            </Typography>
            <Button
              variant="outlined"
              startIcon={<AutoStoriesIcon />}
              onClick={() => navigate("/blog")}
              sx={{
                display: { xs: "none", sm: "flex" },
                backgroundColor: "primary",
                boxShadow: theme.shadows[4],
                ...onHoverStyle,
              }}
            >
              View All Posts
            </Button>
          </Box>

          <Grid container spacing={2} sx={{ mb: { xs: 8, md: 0 } }}>
            {latestPosts.map((post, index) => (
              <Grid item xs={12} md={4} key={post.id}>
                <BlogCard {...post} index={index} />
              </Grid>
            ))}
          </Grid>

          <Box
            sx={{
              display: { xs: "flex", sm: "none" },
              justifyContent: "center",
              mt: 4,
            }}
          >
            <Button
              variant="outlined"
              startIcon={<AutoStoriesIcon />}
              onClick={() => navigate("/blog")}
              sx={{
                backgroundColor: "primary",
                boxShadow: theme.shadows[4],
              }}
            >
              View All Posts
            </Button>
          </Box>
        </motion.div>
      </Container>
    </Box>
  );
};
